exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group {\r\n    margin-top: 10px;\r\n}\r\n\r\n.btn-primary {\r\n    color: black;\r\n    border-color: #FFE600 !important;\r\n    background-color: #FFE600 !important;\r\n}\r\n\r\n.btn-border-right {\r\n    border-bottom-right-radius: 6px;\r\n    border-top-right-radius: 6px;\r\n}\r\n\r\n.btn-border-left {\r\n    border-bottom-left-radius: 6px;\r\n    border-top-left-radius: 6px;\r\n}\r\n\r\n\r\n@media(min-width: 992px) {\r\n    .btn-group {\r\n        margin-top: 2px;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/filter-item/filter-item.component.css
// module id = ../../../../../src/app/shared/filter-item/filter-item.component.css
// module chunks = 16